import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asyncGetUser } from '../../../services/users.service';
import Loading from '../../components/general/loadings/loading';
import UserForm from './form';

const EditUser = () => {
    const { idUser } = useParams();
    const [row, setRow] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [onSave, setOnSave] = useState<boolean>(false);

    useEffect(() => {
        asyncGetUser(idUser).then((body: any) => {
            if (body.items !== undefined) {
                setRow(body.items);
                setLoading(false);
            }
        });
    }, [idUser, onSave]);

    return loading ? (
        <Loading />
    ) : (
        <UserForm
            idUser={idUser}
            user={row}
            onSave={(value: any) => setOnSave(value)}
        />
    );
};

export default EditUser;
